import React from "react";

const VerifiedIcon = (props) => (
  <img src="/verified.svg" alt="Trackit Profile/FLX ID" {...props} />
);

const MeasurablesIcon = (props) => (
  <img src="/Measurables.svg" alt="Official performance metrics" {...props} />
);

const FootageIcon = (props) => (
  <img src="/footage.svg" alt="High-resolution game footage" {...props} />
);

const HeadshotIcon = (props) => (
  <img src="/headshot.svg" alt="Professional athlete headshot" {...props} />
);

const DistributionIcon = (props) => (
  <img src="/college.svg" alt="College distribution" {...props} />
);

const VisibilityIcon = (props) => (
  <img src="/Visibility.svg" alt="Elevated athlete visibility" {...props} />
);

const features = [
  {
    icon: VerifiedIcon,
    title: "Trackit Profile",
    desc: "A fully loaded digital athletic resume — complete, professional, and ready to share.",
  },
  {
    icon: DistributionIcon,
    title: "College Distribution",
    desc: "Your Trackit profile is shared directly with college programs across the country",
  },
  {
    icon: VisibilityIcon,
    title: "Elevated Visibility",
    desc: "Gain exposure through our nationwide recruiting network.",
  },
  {
    icon: MeasurablesIcon,
    title: "Verified Measurables",
    desc: "Official stats and performance metrics captured on-site.",
  },
  {
    icon: FootageIcon,
    title: "High-Resolution Footage",
    desc: "Professional video clips showcasing your skills and strengths.",
  },
  {
    icon: HeadshotIcon,
    title: "Professional Headshot",
    desc: "A polished profile image for your Trackit Profile",
  },
];

export default function LandingPage() {
  return (
    <div className="bg-neutral-900 font-sans">
      {/* What Athlete Receives */}
      <section className="pt-16 pb-0 px-4 max-w-7xl mx-auto">
        <h2 className="text-center text-gray-100 font-bold text-3xl lg:text-4xl uppercase">
          Every athlete will receive
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 lg:gap-4 lg:mt-12 font-sans">
          {features.map((item, idx) => {
            const Icon = item.icon;
            return (
              <div
                key={idx}
                className="p-5 rounded-xl hover:shadow-lg transition duration-300"
              >
                <div className="mb-3">
                  <Icon className="w-12 h-12" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-white">
                  {" "}
                  {item.title}
                </h3>
                <p className="text-base text-gray-100 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
